/**
 * The profile area's two routes, aggregated.
 *
 * The file is `.routes.tsx` (plural) because it exports an ARRAY — the
 * importer knows the shape from the name, which is what the naming rule exists
 * for. Each page keeps its own singular `*.route.tsx`; this file only collects
 * them so `src/router/routes.ts` gains one line per area rather than one per
 * page.
 */
import type { RouteObject } from 'react-router-dom';

import { profileMeRoute } from './me/profile-me.route';
import { profilePublicRoute } from './public/profile-public.route';

export const profileRoutes: RouteObject[] = [profileMeRoute, profilePublicRoute];
